// ngx-mask format: 0* = unlimited digits (excluding leading zeros)
export const OnlyNumberMask: string = '0*';
